import { gregorianToEthiopic } from "ethiopian-calendar-finova";

export function getEthiopicDateTime({
    datetime = new Date(),
    displayHour = false,
    timeFormat = "12h",
}) {
    const dateObj = new Date(datetime);
    const ethiopic = gregorianToEthiopic(dateObj);
    const hourStr =
        displayHour && ethiopic.hour !== undefined
            ? ethiopic.hour.toString().padStart(2, "0")
            : "";
    const minuteStr =
        displayHour && ethiopic.minute !== undefined
            ? ethiopic.minute.toString().padStart(2, "0")
            : "";

    const timeSuffix =
        displayHour && timeFormat === "12h" && ethiopic.ampm
            ? ` ${ethiopic.ampm}`
            : "";

    return (
        <>
            {ethiopic.day}/{ethiopic.month}/{ethiopic.year}
            {displayHour ? ` ${hourStr}:${minuteStr}${timeSuffix}` : ""}
        </>
    );
}